import { describeFields, FieldWidget } from '../common/fields';
import { CLASS_DAY_OPTIONS } from './constants';
import { ClassSchema } from './schemas';

export const CLASS_FIELDS = describeFields(ClassSchema, {
  subject: { widget: FieldWidget.Text },
  code: {},
  slackChannelId: {},
  slackChannelName: {},
  courseId: { widget: FieldWidget.Select },
  streamId: { widget: FieldWidget.Select },
  streamIds: { widget: FieldWidget.MultiSelect },
  day: { widget: FieldWidget.Select, options: CLASS_DAY_OPTIONS },
  time: { widget: FieldWidget.Time },
  teacherId: { widget: FieldWidget.Autocomplete, displayField: 'teacherName' },
  markerId: { widget: FieldWidget.Autocomplete, displayField: 'markerName' },
  tags: {},
  students: {},
  schoolTag: {},
  studentCount: { widget: FieldWidget.Text },
  studentCap: {},
  notes: {},
  active: { widget: FieldWidget.Text },
  waitlist: {},
  location: {},
  roomId: { widget: FieldWidget.Select, displayField: 'roomLabel' },
  remindBreaks: {},
  allowMakeups: {},
});
